import styled, { css } from 'styled-components';

import { radialPadColors } from '../../radialControlPad.constants.ts';

const { color: sectorFillColor, opacity: sectorFillOpacity } = radialPadColors.sector.fill;

export const RadialSectorIconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  margin: 0;
  pointer-events: none;
`;

export const RadialSectorPath = styled.path<{ $active?: boolean; $disabled?: boolean }>`
  stroke: none;
  outline: none;
  fill: ${sectorFillColor};
  fill-opacity: ${sectorFillOpacity.default};
  cursor: pointer;

  transition: fill-opacity 0.12s ease-out;

  ${({ $disabled }) =>
    !$disabled &&
    css`
      &:hover {
        fill-opacity: ${sectorFillOpacity.hover};
      }

      &:focus-visible {
        fill-opacity: ${sectorFillOpacity.focus};
      }
    `}

  ${({ $active, $disabled }) =>
    $active &&
    !$disabled &&
    css`
      &,
      &:hover,
      &:focus-visible {
        fill-opacity: ${sectorFillOpacity.pressed};
      }
    `}

  ${({ $disabled }) =>
    $disabled &&
    css`
      fill-opacity: ${sectorFillOpacity.disabled};
      cursor: not-allowed;
      pointer-events: none;
    `}
`;
